import { Box, Chip, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { FC } from "react";

export interface FixedEnumValuesPreviewProps {
  values: readonly string[];
}

// Read-only preview for fields backed by a fixed application enum (e.g. recordType,
// criticality). Unlike dropdownFieldOneDefinition/secondCategoryDefinition, these values
// aren't stored per-configuration, so there's nothing here to add, remove, or rename.
export const FixedEnumValuesPreview: FC<FixedEnumValuesPreviewProps> = ({
  values,
}) => {
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%" }}
    >
      <Typography sx={{ fontSize: "12px", color: grey[600] }}>
        Fixed values (not editable here)
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {values.map((value) => (
          <Chip key={value} label={value} size="small" variant="outlined" />
        ))}
      </Box>
    </Box>
  );
};
